export const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: 20,
    color: '#333',
    fontSize: 12
  },
  header: {
    textAlign: 'right',
    marginBottom: 30
  },
  headerH1: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 4
  },
  headerP: {
    fontSize: 9,
    margin: '2px 0'
  },
  infoBeforeTitle: {
    textAlign: 'right',
    marginBottom: 10,
    fontSize: 10,
    lineHeight: 1.4
  },
  title: {
    textAlign: 'center',
    fontSize: 22,
    fontWeight: 'bold',
    margin: '10px 0 30px 0'
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    margin: '20px 0 10px 0'
  },
  label: {
    fontWeight: 'bold',
    fontSize: 12
  },
  clientInfo: {
    marginBottom: 16,
    lineHeight: 1.3,
    fontSize: 11
  },
  clientInfoLine: {
    marginBottom: 2
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    margin: '15px 0'
  },
  th: {
    backgroundColor: '#838383ff',
    color: '#fff',
    padding: 8,
    textAlign: 'left',
    fontSize: 11,
    fontWeight: 'bold'
  },
  thProduct: {
    backgroundColor: '#838383ff',
    color: '#fff',
    padding: 8,
    textAlign: 'left',
    fontSize: 11,
    fontWeight: 'bold',
    width: '50%'
  },
  thQuantity: {
    backgroundColor: '#838383ff',
    color: '#fff',
    padding: 8,
    textAlign: 'center',
    fontSize: 11,
    fontWeight: 'bold',
    width: '15%'
  },
  thUnitValue: {
    backgroundColor: '#838383ff',
    color: '#fff',
    padding: 8,
    textAlign: 'right',
    fontSize: 11,
    fontWeight: 'bold',
    width: '17.5%'
  },
  thTotalValue: {
    backgroundColor: '#838383ff',
    color: '#fff',
    padding: 8,
    textAlign: 'right',
    fontSize: 11,
    fontWeight: 'bold',
    width: '17.5%'
  },
  td: {
    padding: 8,
    border: '1px solid #ddd',
    fontSize: 11
  },
  right: {
    textAlign: 'right'
  },
  center: {
    textAlign: 'center'
  },
  subtotalRow: {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold'
  },
  paymentTable: {
    marginTop: 20
  },
  otherInfo: {
    marginTop: 30,
    lineHeight: 1.6
  },
  footer: {
    marginTop: 20,
    fontSize: 11
  },
  budgetInfo: {
    marginBottom: 20,
    lineHeight: 1.6
  }
};
